import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { CONVERSATION_LENS } from "../../../utils/terminology";
import { CoachingArtifact } from "../hooks/useCoachingArtifacts";
import { formatUserNameFromEmail } from "../utils/formatUserName";

interface MetadataFieldProps {
  label: string;
  value: string;
}

const MetadataField = ({ label, value }: MetadataFieldProps) => (
  <Grid size={{ xs: 12, md: 4 }}>
    <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", fontWeight: 500 }}>
      {label}
    </Typography>
    <Typography variant="body1">
      {value}
    </Typography>
  </Grid>
);

interface CoachingArtifactMetadataProps {
  artifact: CoachingArtifact;
  createdByEmail?: string;
  reportTitle?: string;
}

const CoachingArtifactMetadata = ({ artifact, createdByEmail, reportTitle }: CoachingArtifactMetadataProps) => {
  const metadataFields: MetadataFieldProps[] = [
    ...(reportTitle ? [{ label: "Report Title", value: reportTitle }] : []),
    { label: "User", value: formatUserNameFromEmail(artifact.agent_email) },
    { label: CONVERSATION_LENS, value: artifact.lens_name },
    { label: "Date Range", value: `${new Date(artifact.start_date).toLocaleDateString()} - ${new Date(artifact.end_date).toLocaleDateString()}` },
    { label: "Generated", value: new Date(artifact.created).toLocaleString() },
    { label: "Created By", value: createdByEmail || artifact.created_by || "Unknown" }
  ];

  return (
    <Box sx={{ px: 3, py: 3 }}>
      <Grid container spacing={3}>
        {metadataFields.map((field) => (
          <MetadataField key={field.label} {...field} />
        ))}
      </Grid>
    </Box>
  );
};

export default CoachingArtifactMetadata;
